// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.code-error-page {
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
}

.error-container {
  background: white;
  border-radius: 16px;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  max-width: 600px;
  width: 100%;
  overflow: hidden;
}

.error-content {
  padding: 40px;
  text-align: center;
}

.error-icon {
  font-size: 4rem;
  margin-bottom: 20px;
  display: block;
}

.error-title {
  color: #1f2937;
  font-size: 2rem;
  font-weight: 700;
  margin: 0 0 16px 0;
  line-height: 1.2;
}

.error-description {
  color: #6b7280;
  font-size: 1.1rem;
  margin: 0 0 24px 0;
  line-height: 1.6;
}

.error-code-info {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  padding: 16px;
  margin: 24px 0;
}

.code-display {
  background: #374151;
  color: #f9fafb;
  padding: 4px 8px;
  border-radius: 4px;
  font-family: 'Courier New', monospace;
  font-weight: 700;
  letter-spacing: 1px;
}

.error-message-detail {
  background: #fef2f2;
  border: 1px solid #fecaca;
  border-radius: 8px;
  padding: 16px;
  margin: 24px 0;
}

.error-detail {
  color: #b91c1c;
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.5;
}

.error-actions {
  text-align: left;
  margin-top: 32px;
}

.primary-action {
  background: #eff6ff;
  border: 1px solid #dbeafe;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 24px;
}

.primary-action h3 {
  color: #1e40af;
  margin: 0 0 8px 0;
  font-size: 1.1rem;
  font-weight: 600;
}

.primary-action p {
  color: #1e40af;
  margin: 0;
  font-size: 1rem;
  line-height: 1.5;
}

.retry-btn {
  background: #3b82f6;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-bottom: 24px;
  width: 100%;
}

.retry-btn:hover {
  background: #2563eb;
  transform: translateY(-1px);
}

.help-info {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 24px;
}

.help-info h4 {
  color: #374151;
  margin: 0 0 16px 0;
  font-size: 1.1rem;
  font-weight: 600;
}

.help-info ul {
  margin: 0;
  padding-left: 0;
  list-style: none;
}

.help-info li {
  margin-bottom: 12px;
  padding-left: 20px;
  position: relative;
  color: #4b5563;
  line-height: 1.5;
}

.help-info li:before {
  content: "•";
  color: #6b7280;
  font-weight: bold;
  position: absolute;
  left: 0;
}

.help-info strong {
  color: #374151;
}

.error-footer {
  background: #f9fafb;
  border-top: 1px solid #e5e7eb;
  padding: 24px 40px;
}

.security-note {
  margin: 0;
  color: #6b7280;
  font-size: 0.9rem;
  line-height: 1.5;
  text-align: center;
}

.security-note strong {
  color: #374151;
}

/* Error Type Specific Styles */
.error-container[data-error-type="deactivated"] .error-icon {
  color: #dc2626;
}

.error-container[data-error-type="expired"] .error-icon {
  color: #d97706;
}

.error-container[data-error-type="invalid"] .error-icon {
  color: #dc2626;
}

/* Responsive Design */
@media (max-width: 768px) {
  .code-error-page {
    padding: 10px;
  }
  
  .error-content {
    padding: 24px;
  }
  
  .error-title {
    font-size: 1.5rem;
  }
  
  .error-icon {
    font-size: 3rem;
  }
  
  .error-footer {
    padding: 20px 24px;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/CodeErrorPage.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,gFAAgF;AAClF;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,qFAAqF;EACrF,gBAAgB;EAChB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,OAAO;AACT;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".code-error-page {\n  min-height: 100vh;\n  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;\n}\n\n.error-container {\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);\n  max-width: 600px;\n  width: 100%;\n  overflow: hidden;\n}\n\n.error-content {\n  padding: 40px;\n  text-align: center;\n}\n\n.error-icon {\n  font-size: 4rem;\n  margin-bottom: 20px;\n  display: block;\n}\n\n.error-title {\n  color: #1f2937;\n  font-size: 2rem;\n  font-weight: 700;\n  margin: 0 0 16px 0;\n  line-height: 1.2;\n}\n\n.error-description {\n  color: #6b7280;\n  font-size: 1.1rem;\n  margin: 0 0 24px 0;\n  line-height: 1.6;\n}\n\n.error-code-info {\n  background: #f9fafb;\n  border: 1px solid #e5e7eb;\n  border-radius: 8px;\n  padding: 16px;\n  margin: 24px 0;\n}\n\n.code-display {\n  background: #374151;\n  color: #f9fafb;\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-family: 'Courier New', monospace;\n  font-weight: 700;\n  letter-spacing: 1px;\n}\n\n.error-message-detail {\n  background: #fef2f2;\n  border: 1px solid #fecaca;\n  border-radius: 8px;\n  padding: 16px;\n  margin: 24px 0;\n}\n\n.error-detail {\n  color: #b91c1c;\n  margin: 0;\n  font-size: 0.95rem;\n  line-height: 1.5;\n}\n\n.error-actions {\n  text-align: left;\n  margin-top: 32px;\n}\n\n.primary-action {\n  background: #eff6ff;\n  border: 1px solid #dbeafe;\n  border-radius: 12px;\n  padding: 24px;\n  margin-bottom: 24px;\n}\n\n.primary-action h3 {\n  color: #1e40af;\n  margin: 0 0 8px 0;\n  font-size: 1.1rem;\n  font-weight: 600;\n}\n\n.primary-action p {\n  color: #1e40af;\n  margin: 0;\n  font-size: 1rem;\n  line-height: 1.5;\n}\n\n.retry-btn {\n  background: #3b82f6;\n  color: white;\n  border: none;\n  padding: 12px 24px;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-bottom: 24px;\n  width: 100%;\n}\n\n.retry-btn:hover {\n  background: #2563eb;\n  transform: translateY(-1px);\n}\n\n.help-info {\n  background: #f8fafc;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 24px;\n}\n\n.help-info h4 {\n  color: #374151;\n  margin: 0 0 16px 0;\n  font-size: 1.1rem;\n  font-weight: 600;\n}\n\n.help-info ul {\n  margin: 0;\n  padding-left: 0;\n  list-style: none;\n}\n\n.help-info li {\n  margin-bottom: 12px;\n  padding-left: 20px;\n  position: relative;\n  color: #4b5563;\n  line-height: 1.5;\n}\n\n.help-info li:before {\n  content: \"•\";\n  color: #6b7280;\n  font-weight: bold;\n  position: absolute;\n  left: 0;\n}\n\n.help-info strong {\n  color: #374151;\n}\n\n.error-footer {\n  background: #f9fafb;\n  border-top: 1px solid #e5e7eb;\n  padding: 24px 40px;\n}\n\n.security-note {\n  margin: 0;\n  color: #6b7280;\n  font-size: 0.9rem;\n  line-height: 1.5;\n  text-align: center;\n}\n\n.security-note strong {\n  color: #374151;\n}\n\n/* Error Type Specific Styles */\n.error-container[data-error-type=\"deactivated\"] .error-icon {\n  color: #dc2626;\n}\n\n.error-container[data-error-type=\"expired\"] .error-icon {\n  color: #d97706;\n}\n\n.error-container[data-error-type=\"invalid\"] .error-icon {\n  color: #dc2626;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .code-error-page {\n    padding: 10px;\n  }\n  \n  .error-content {\n    padding: 24px;\n  }\n  \n  .error-title {\n    font-size: 1.5rem;\n  }\n  \n  .error-icon {\n    font-size: 3rem;\n  }\n  \n  .error-footer {\n    padding: 20px 24px;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
